import { configureStore } from '@reduxjs/toolkit';
// Новые слайсы
// import electricityReducer from './slices/electricitySlice';
// import supervisionReducer from './slices/supervisionSlice';
// import appReducer from './slices/appSlice';
// Существующие редюсеры
import helperReducer from './reducers/helpersReducer';
import tasksReducer from './reducers/tasksReducer';
import stateReducer from './reducers/stateReducer';
import notificationReducer from './reducers/notificationSlice';
// Middleware
// import filterSyncMiddleware from './middleware/filterSyncMiddleware';

const store = configureStore({
  reducer: {
    // Новые слайсы
    // electricity: electricityReducer,
    // supervision: supervisionReducer,
    // app: appReducer,
    
    // Существующие редюсеры
    state: stateReducer,
    helper: helperReducer,
    tasks: tasksReducer,
    notification: notificationReducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    immutableCheck: false,
    serializableCheck: false,
  })
});

export default store;
